<template>
  <div class="config-page">
    <PointTable v-if="activeTab === 'point-table'" />
    <ProductModel v-if="activeTab === 'product-model'" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import PointTable from './PointTable/index.vue'
import ProductModel from './ProductModel/index.vue'

const route = useRoute()
const activeTab = ref(route.query.subTab || 'point-table')
</script>
<style scoped>
.config-page {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  overflow: hidden;
}
</style>
